import { render } from "./TypeProdottoList.vue?vue&type=template&id=c29e2100"
import script from "./TypeProdottoList.vue?vue&type=script&lang=js"
export * from "./TypeProdottoList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__